<!--
 * @Descripttion: 日期时间组件
 * @Author: zenghua.wang
 * @Date: 2021-12-06 16:11:42
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-12-23 15:15:35
-->
<template>
  <div
    :class="setClass()"
    :style="styleSize"
    :ref="id"
  >
    <div
      :class="setClass('panel')"
      :style="styleDatetime"
    >
      {{nowDate}}
    </div>
  </div>
</template>
<script>
import bem from '@/dragComponents/mixins/bem'
import { setPx, formatDate2Str } from '@/dragComponents/utils'
import { component } from '@/dragComponents/model/default.js'

export default {
  name: 'drag-datetime',
  mixins: [bem],
  components: {},
  inject: ['category', 'device'],
  props: {
    id: {
      type: String
    },
    width: {
      type: [Number, String],
      default: 100
    },
    height: {
      type: [Number, String],
      default: 36
    },
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    select: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      date: new Date(),
      dateHandle: null,
      formaterList: [
        {
          type: 'date',
          formater: 'YYYY-MM-DD'
        },
        {
          type: 'datetime',
          formater: 'YYYY-MM-DD HH:mm:ss'
        },
        {
          type: 'time',
          formater: 'HH:mm:ss'
        },
        {
          type: 'year-month',
          formater: 'YYYY-MM'
        },
        {
          type: 'month-day',
          formater: 'MM-DD'
        },
        {
          type: 'day',
          formater: 'd'
        }
      ]
    }
  },
  computed: {
    styleSize() {
      const { design } = component
      return Object.assign(
        (() => {
          // 设计时
          if (!this.disabled) {
            return {
              background: this.category === 'report' ? design.bg : 'none',
              border: (() => {
                return this.styleActive ? design.activeDashed : '0'
              })()
            }
          }
          return {}
        })(),
        {
          width: setPx(this.maxWidth - this.option.margin * 2),
          height: setPx(this.height),
          marginLeft: setPx(this.option.margin),
          marginRight: setPx(this.option.margin)
        }
      )
    },
    styleActive() {
      return !this.disabled && this.select.prop === this.id
    },
    styleDatetime() {
      return {
        width: '100%',
        height: '100%',
        lineHeight: setPx(this.height),
        textAlign: this.option.textAlign,
        // letterSpacing: setPx(this.option.split),
        // backgroundColor: this.option.backgroundColor,
        fontWeight: this.option.fontWeight,
        fontSize: setPx(this.option.fontSize),
        color: this.option.color
      }
    },
    nowDate() {
      this.formaterList.forEach((item) => {
        if (item.type === this.option.type) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.option.formater = item.formater
        }
      })
      let str = formatDate2Str(this.date, this.option.formater)
      if (this.option.type === 'day') {
        return this.formaterWeek(str)
      }
      return str
    }
  },
  watch: {
    'option.type'(val) {
      if (['datetime', 'time'].includes(val)) {
        this.init()
      } else {
        this.dateHandle && clearInterval(this.dateHandle)
        this.dateHandle = null
      }
    }
  },
  methods: {
    init() {
      if (['datetime', 'time'].includes(this.option.type)) {
        this.dateHandle = setInterval(() => {
          this.date = new Date()
        }, 1000)
      } else {
        this.date = new Date()
      }
    },
    formaterWeek(str) {
      switch (str) {
        case '0':
          str = '星期日'
          break
        case '1':
          str = '星期一'
          break
        case '2':
          str = '星期二'
          break
        case '3':
          str = '星期三'
          break
        case '4':
          str = '星期四'
          break
        case '5':
          str = '星期五'
          break
        case '6':
          str = '星期六'
          break
      }
      return str
    }
  },
  created() {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
@import '@/dragComponents/styles/variables.scss';
.drag-datetime {
  overflow: hidden;
  box-sizing: border-box;
  white-space: nowrap;

  &-panel {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}
</style>
